module.exports = __webpack_public_path__ + "02c24a711b685efbd3fe446d82f35232.svg";